import React, { useEffect, useState } from 'react'

import { Box, Card, CardBody, Heading, Stack, Text } from '@chakra-ui/react'

import { terms } from './terms'
import { SearchBar } from '../../../ui'

const Glossary = () => {
  const [filteredTerms, setFilteredTerms] = useState(terms)
  const [search, setSearch] = useState('')

  useEffect(() => {
    setFilteredTerms(
      terms.filter(({ term, definition }) => {
        const lowerSearch = search.toLowerCase()
        return (
          term.toLowerCase().includes(lowerSearch) ||
          definition.toLowerCase().includes(lowerSearch)
        )
      })
    )
  }, [search])

  const getHighlightedText = (text, search) => {
    if (!search) return text

    const regex = new RegExp(`(${search})`, 'gi')
    const parts = text.split(regex)

    return parts.map((part, i) =>
      part.toLowerCase() === search.toLowerCase() ? (
        <span
          key={i}
          style={{ backgroundColor: '#fef08a', fontWeight: 'bold' }}
        >
          {part}
        </span>
      ) : (
        <React.Fragment key={i}>{part}</React.Fragment>
      )
    )
  }

  return (
    <Box h='full' overflow='scroll'>
      <Box gap={4} mb={4}>
        <Heading mb={4} fontSize='xl'>
          Glossary of Terms
        </Heading>

        <SearchBar
          searchValue={search}
          setSearchValue={setSearch}
          placeholder='Search for a term'
        />
      </Box>

      <Stack>
        {filteredTerms.length ? (
          filteredTerms.map(({ term, definition }, index) => {
            return (
              <Card key={`term-${index}`}>
                <CardBody>
                  <Text variant='subheading-blue'>
                    {getHighlightedText(term, search)}
                  </Text>
                  <Text>{getHighlightedText(definition, search)}</Text>
                </CardBody>
              </Card>
            )
          })
        ) : (
          <Box>No terms found! Please update your search. </Box>
        )}
      </Stack>
    </Box>
  )
}

export default Glossary
